/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as DownloadRouteImport } from './routes/download'
import { Route as LeaderboardRouteImport } from './routes/leaderboard'
import { Route as LoginRouteImport } from './routes/login'
import { Route as PlayRouteImport } from './routes/play'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const DownloadRoute = DownloadRouteImport.update({
  id: '/download',
  path: '/download',
  getParentRoute: () => rootRouteImport,
} as any)
const LeaderboardRoute = LeaderboardRouteImport.update({
  id: '/leaderboard',
  path: '/leaderboard',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const PlayRoute = PlayRouteImport.update({
  id: '/play',
  path: '/play',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/download': typeof DownloadRoute
  '/leaderboard': typeof LeaderboardRoute
  '/login': typeof LoginRoute
  '/play': typeof PlayRoute
  '/privacy': typeof PrivacyRoute
  '/profile': typeof ProfileRoute
  '/register': typeof RegisterRoute
  '/terms': typeof TermsRoute
  '/verify-email': typeof VerifyEmailRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/download': typeof DownloadRoute
  '/leaderboard': typeof LeaderboardRoute
  '/login': typeof LoginRoute
  '/play': typeof PlayRoute
  '/privacy': typeof PrivacyRoute
  '/profile': typeof ProfileRoute
  '/register': typeof RegisterRoute
  '/terms': typeof TermsRoute
  '/verify-email': typeof VerifyEmailRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/download': typeof DownloadRoute
  '/leaderboard': typeof LeaderboardRoute
  '/login': typeof LoginRoute
  '/play': typeof PlayRoute
  '/privacy': typeof PrivacyRoute
  '/profile': typeof ProfileRoute
  '/register': typeof RegisterRoute
  '/terms': typeof TermsRoute
  '/verify-email': typeof VerifyEmailRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/download'
    | '/leaderboard'
    | '/login'
    | '/play'
    | '/privacy'
    | '/profile'
    | '/register'
    | '/terms'
    | '/verify-email'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin'
    | '/download'
    | '/leaderboard'
    | '/login'
    | '/play'
    | '/privacy'
    | '/profile'
    | '/register'
    | '/terms'
    | '/verify-email'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/download'
    | '/leaderboard'
    | '/login'
    | '/play'
    | '/privacy'
    | '/profile'
    | '/register'
    | '/terms'
    | '/verify-email'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRoute
  DownloadRoute: typeof DownloadRoute
  LeaderboardRoute: typeof LeaderboardRoute
  LoginRoute: typeof LoginRoute
  PlayRoute: typeof PlayRoute
  PrivacyRoute: typeof PrivacyRoute
  ProfileRoute: typeof ProfileRoute
  RegisterRoute: typeof RegisterRoute
  TermsRoute: typeof TermsRoute
  VerifyEmailRoute: typeof VerifyEmailRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/download': {
      id: '/download'
      path: '/download'
      fullPath: '/download'
      preLoaderRoute: typeof DownloadRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/leaderboard': {
      id: '/leaderboard'
      path: '/leaderboard'
      fullPath: '/leaderboard'
      preLoaderRoute: typeof LeaderboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/play': {
      id: '/play'
      path: '/play'
      fullPath: '/play'
      preLoaderRoute: typeof PlayRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRoute,
  DownloadRoute: DownloadRoute,
  LeaderboardRoute: LeaderboardRoute,
  LoginRoute: LoginRoute,
  PlayRoute: PlayRoute,
  PrivacyRoute: PrivacyRoute,
  ProfileRoute: ProfileRoute,
  RegisterRoute: RegisterRoute,
  TermsRoute: TermsRoute,
  VerifyEmailRoute: VerifyEmailRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
